import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from './styles.scss';

export interface FAQSectionThreeProps {
  localizeMessage: (key: string) => string;
}

export const FAQSectionThree: React.FC<FAQSectionThreeProps> = ({ localizeMessage }) => (
  <Box mt={2}>
    <Typography
      variant="h6"
      style={{ fontWeight: 600 }}
      color="textSecondary"
      gutterBottom
      className={styles['faq-section-title']}
    >
      {localizeMessage('faqSectionPersonalInformation')}
    </Typography>
    <div className={styles.faqCard}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ11')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA11')}</Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  </Box>
);
